/**
 * Observer
 */
export default class Observer {
    /**
     * Constructor
     */
    constructor() {
        this.observers = {};
    }

    /**
     *  on
     */
    on(type, cb) {
        if (!(type in this.observers)) {
            this.observers[type] = [];
        }

        this.observers[type].push(cb);
    }

    /**
     * emit
     */
    emit(type, ...args) {
        if (!(type in this.observers)) {
            return;
        }

        const e = window.event || new CustomEvent(type, { detail: { ...args } });
        this.observers[type].forEach(cb => cb(...[e, ...args]));
    }
}
